export const GET_TAREQUEST = 'GET_TAREQUEST';
export const SET_TAREQUEST = 'SET_TAREQUEST';
export const CLEAR_TAREQUEST = 'CLEAR_TAREQUEST';
